import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import GiftCards from "@/pages/GiftCards";
import Auth from "@/pages/Auth";
import Account from "@/pages/Account";
import { PaymentCancel, PaymentSuccess } from "@/pages/PaymentResult";

function ScrollReset() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain bg-[#09090B] min-h-screen">
      <AuthProvider>
        <BrowserRouter>
          <ScrollReset />
          <Nav />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/book" element={<Booking />} />
            <Route path="/gift-cards" element={<GiftCards />} />
            <Route path="/login" element={<Auth />} />
            <Route path="/register" element={<Auth />} />
            <Route path="/account" element={<Account />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
          <Footer />
          <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#141417", border: "1px solid rgba(212,175,55,0.25)", color: "#F4F4F5" } }} />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
